import React from 'react';
import DatePicker from '@adsk/alloy-react-date-picker';
import Button from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-helpers';
import PropTypes from 'prop-types';

const DatePickerCustomFooter = ({ today, reset }) => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));

  return (
    <DatePicker.Footer>
      <Button onClick={today} size={Button.SIZES.SMALL}>
        {T.translate('TODAY')}
      </Button>
      <Button
        variant={Button.VARIANTS.TERTIARY}
        size={Button.SIZES.SMALL}
        onClick={reset}
      >
        {T.translate('RESET_SELECTION')}
      </Button>
    </DatePicker.Footer>
  );
};

DatePickerCustomFooter.propTypes = {
  today: PropTypes.func,
  reset: PropTypes.func,
};

export default DatePickerCustomFooter;
